import { Injectable } from '@angular/core';
//import { Network } from '@ionic-native/network/ngx';//获取网络情况
import { Device } from '@ionic-native/device/ngx';//获取手机硬件设备
import { Platform } from '@ionic/angular';//获取是否手机
// import { HotCodePush } from '@ionic-native/hot-code-push/ngx';//热更新
import { Camera,CameraOptions } from '@ionic-native/camera/ngx';//相机
import { ImagePicker,ImagePickerOptions } from '@ionic-native/image-picker/ngx';//相册获取照片
import {MessageclientService} from '../service/messageclient.service';
// import { CallNumber } from '@ionic-native/call-number/ngx';//打电话
// import { SMS } from '@ionic-native/sms/ngx';//发送短信
import {CommonService} from './common.service';
import { Sim } from '@ionic-native/sim/ngx'; //获取sim卡信息
import { FileTransfer, FileUploadOptions, FileTransferObject } from '@ionic-native/file-transfer/ngx';
// import { HttpHeaders } from '@angular/common/http';
// import { HttpHeader } from '../service/static.service';
// import {InAppBrowser} from '@ionic-native/in-app-browser';
//  import { AppUpdate } from '@ionic-native/app-update/ngx';//安装android端APP
// import { ZBarOriginal, ZBarOptions } from '@ionic-native/zbar';//扫描二维码
import {File} from '@ionic-native/file/ngx';
import { WebResponesContext } from '../model/common';
import { Base64}  from '@ionic-native/base64/ngx';
import { FileOpener } from '@ionic-native/file-opener/ngx';
declare var app;
declare var imageConversion;
declare var QRCode;//生成二维码
declare var IosSelect;//下拉控件
@Injectable({
  providedIn: 'root'
})
export class NativeService {

  constructor(
    //private network:Network,
    public device: Device,
    private platform: Platform,
    // private hot:HotCodePush,
    private camera: Camera,
    private imagePicker: ImagePicker,
    private msg: MessageclientService,
    public fileOpener:FileOpener,
    // private callNumber: CallNumber,
    // private sms: SMS,
    private common: CommonService,
    private sim: Sim,
    private file:File,
    private base64:Base64
    // private appUpdate:AppUpdate
    // private zbar:ZBarOriginal
   
    ) { }
  /**
   * 获取移动设备系统版本号 例如android:6.0
   */
  get GetVersion():string{
   return this.device.version;
  
  }
  
  /**
   * 获取移动设备的模型或产品名称
   */
  get GetModel(): string {
    return this.device.model || "";
  }
  /**
   * 获取移动设备制造商 例:huawei
   */
  get GetBrand(): string {
    return this.device.manufacturer || "";
  }
  /**
   * 获取移动设备操作系统名称 例:Android,ios,windows;
   */
  get GetSystem(): string {
    return this.device.platform || "";
  }
  /**
   * 获取移动设备序列号
   */
  get GetSerial(): string {
    return this.device.serial || "";
  }
  /**
   * 获取移动设备通用唯一标识uuid，例如：‘78ca1fe2c1d3b584’
   */
  get GetUUid(): string {
    return this.device.uuid || "";
  }
   /**
     * 是否真机环境,Android/ios(不包含移动端浏览器)
     * @return {boolean}
     */
    get isMobile(): boolean {
      return this.platform.is( 'cordova' );
    }
    /**
     * 是否移动端浏览器打开
     */
    get isMobileweb(): boolean {
      return this.platform.is( 'desktop' );
    }
  /**
   * 是否android真机环境
   * @return {boolean}
   */
  get isAndroid(): boolean {

    return this.platform.is( 'android' );
  }
  /**
   * 是否ios真机环境
   * @return {boolean}
   */
  get isIos(): boolean {
  

    return this.platform.is( 'ios' ) || this.platform.is( 'ipad' ) || this.platform.is( 'iphone' );
  }
  /**
   * 根据相机获取照片
   * @param _option 配置信息，参考CameraOptions实体类,使用方法导入:import {CameraOptions } from '@ionic-native/camera/ngx';
   */
  getCameraPicture(_option:CameraOptions={}):Promise<any>{
   const that =this;
   console.log(_option,"拍照参数配置");
    /**配置信息 */
    let options: CameraOptions = Object.assign({
      destinationType: that.camera.DestinationType.DATA_URL,
      encodingType: that.camera.EncodingType.JPEG,
      correctOrientation:true,//矫正拍照角度
      quality: 20,//图像质量，范围为0 - 100
      // targetWidth: 400,//缩放图像的宽度（像素）
      // targetHeight: 300,//缩放图像的高度（像素）
      mediaType: that.camera.MediaType.PICTURE,
      allowEdit: false,//选择图片前是否允许编辑
      saveToPhotoAlbum: false,//是否保存到相册
      // correctOrientation: true,//设置摄像机拍摄的图像是否为正确的方向
      sourceType:that.camera.PictureSourceType.CAMERA//拍照选择相机
    },_option);
    // console.log("pic");
    if(that.isMobile){
      return that.camera.getPicture(options);
    }else{
      return that.msg.ErrorMessage("非手机端不可使用");
    }
  }

    /**
   * 根据相机获取照片绝对地址
   * @param _option 配置信息，参考CameraOptions实体类,使用方法导入:import {CameraOptions } from '@ionic-native/camera/ngx';
   */
  getCameraPictureUrl(_option:CameraOptions={}):Promise<any>{
    const that =this;
    console.log(_option,"拍照参数");
     /**配置信息 */
     let options: CameraOptions = Object.assign({
       destinationType: that.camera.DestinationType.FILE_URI,
       encodingType: that.camera.EncodingType.JPEG,
       correctOrientation:true,//矫正拍照角度
       quality: 20,//图像质量，范围为0 - 100
       // targetWidth: 400,//缩放图像的宽度（像素）
       // targetHeight: 300,//缩放图像的高度（像素）
       mediaType: that.camera.MediaType.PICTURE,
       allowEdit: false,//选择图片前是否允许编辑
       saveToPhotoAlbum: false,//是否保存到相册
       // correctOrientation: true,//设置摄像机拍摄的图像是否为正确的方向
       sourceType:that.camera.PictureSourceType.CAMERA//拍照选择相机
     },_option);
     // console.log("pic");
     if(that.isMobile){
       return that.camera.getPicture(options);
     }else{
       return that.msg.ErrorMessage("非手机端不可使用");
     }
   }

      /**
   * 根据相册获取照片绝对地址
   * @param _option 配置信息，参考CameraOptions实体类,使用方法导入:import {ImagePickerOptions } from '@ionic-native/image-picker/ngx';
   */
  getImagePickerUrl(_option:CameraOptions={}):Promise<any>{
    const that =this;
    console.log(_option,"拍照参数");
     /**配置信息 */
     let options: CameraOptions = Object.assign({
       sourceType:that.camera.PictureSourceType.PHOTOLIBRARY,//拍照选择相机
       destinationType: that.camera.DestinationType.FILE_URI,
       encodingType: that.camera.EncodingType.JPEG,
       quality: 10,//图像质量，范围为0 - 100
       // targetWidth: 400,//缩放图像的宽度（像素）
       // targetHeight: 300,//缩放图像的高度（像素）
       mediaType: that.camera.MediaType.PICTURE,
       allowEdit: false,//选择图片前是否允许编辑
       // correctOrientation: true,//设置摄像机拍摄的图像是否为正确的方向
     },_option);
     // console.log("pic");
     if(that.isMobile){
       return that.camera.getPicture(options);
     }else{
       return that.msg.ErrorMessage("非手机端不可使用");
     }
   }
  
  /**
   * 获取相册照片
   * @param options  配置信息，参考CameraOptions实体类,使用方法导入:import { ImagePickerOptions } from '@ionic-native/image-picker/ngx';
   */
  getPicture(options:CameraOptions={}):Promise<any>{
    options.sourceType = this.camera.PictureSourceType.PHOTOLIBRARY;
    options.destinationType = this.camera.DestinationType.FILE_URI;
    options.encodingType = this.camera.EncodingType.JPEG;
    options.quality = 20,//图像质量，范围为0 - 100
    // options.targetWidth = 1280;//缩放图像的宽度（像素）
    // options.targetHeight = 720;//缩放图像的高度（像素）
    options.mediaType = this.camera.MediaType.PICTURE;
    options.allowEdit =  true;//选择图片前是否允许编辑
    if(this.isMobile){
      return this.camera.getPicture(options);
    }else{
      return this.msg.ErrorMessage("非手机端不可使用");
    }
    
  }

    /**
   * 获取相册照片 返回base64
   * @param options  配置信息，参考CameraOptions实体类,使用方法导入:import { ImagePickerOptions } from '@ionic-native/image-picker/ngx';
   */
  getPictureBase64(options:CameraOptions={}):Promise<any>{
    options.sourceType = this.camera.PictureSourceType.PHOTOLIBRARY;
    options.destinationType = this.camera.DestinationType.DATA_URL;
    options.encodingType = this.camera.EncodingType.JPEG;
    options.quality = 20,//图像质量，范围为0 - 100
    // options.targetWidth = 300;//缩放图像的宽度（像素）
    // options.targetHeight = 300;//缩放图像的高度（像素）
    options.mediaType = this.camera.MediaType.PICTURE;
    options.allowEdit =  true;//选择图片前是否允许编辑
    if(this.isMobile){
      return this.camera.getPicture(options);
    }else{
      return this.msg.ErrorMessage("非手机端不可使用");
    }
    
  }
  /**
   * 获取多个文件
   */
  GetMuiltPicture():Promise<any>{
    const that= this;
    return new Promise<any>((jeson,reject)=>{
      that.imagePicker.requestReadPermission().then(data=>{
        let option:ImagePickerOptions = {};
        option.outputType = 0;
        return that.imagePicker.getPictures(option);
      }).catch(err0r=>{
        reject(err0r);
      });
    });
  }
  /**
   * 上传文件到服务器
   * @param FILE_URI 当前文件的地址
   */
  UploadPictures(FILE_URI:string):Promise<any>{
    const that = this;
    let transfer = new FileTransfer();
    const fileTransfer: FileTransferObject = transfer.create();
   let options: FileUploadOptions = {
      fileKey: 'file',
      fileName: 'name.jpg',
      // mimeType: "image/jpeg",
      httpMethod: "post",
      headers:null
   };
      // options.headers = that.getHttpHeaders();
      if(FILE_URI.indexOf('?')>=0){
        FILE_URI = FILE_URI.substr(0,FILE_URI.lastIndexOf('?'));
      }
      options.fileName=FILE_URI.substr(FILE_URI.lastIndexOf('/')+1);
      console.log("文件上传");
      return new Promise<any>((resolve,reason)=>{
        fileTransfer.upload(FILE_URI,app.UPLOADURL,options).then(data=>{
          console.log("文件上传10");
          if(data.responseCode == 200){
            let message = JSON.parse(data.response);
            if(message.ResponseMessage.Success){
              message.Status.forEach((element,index) => {
                message.Status[index].FileHostName = app.WEBSITE+element.FileHostName;
              });
            }
            resolve(message);
          }
       }).catch(error=>{
         console.log(error);
         reason(error);
         that.msg.Show("上传失败,请联系管理员");
       });
      });
  }
  /**
   * 文件上传
   * @param FILE_URI 需要上传的文件路径
   * @param obj 需要传递的参数
   * @param mimeType 文件mimeType类型 默认'image/jpeg'
   */
  UploadFile(FILE_URI:string,obj:any={},mimeType:any="image/jpeg"):Promise<any>{
    const that = this;
    return new Promise<any>((resolve,reason)=>{
      let transfer = new FileTransfer();
      const fileTransfer: FileTransferObject = transfer.create();
      let options: FileUploadOptions = {
          httpMethod: "post",
          headers:null
      };
      options.mimeType=mimeType;//文件mimeType类型
         let index:number= FILE_URI.lastIndexOf("\/")+1;
         let filesname = FILE_URI.substring(index,FILE_URI.length);//获取文件名称
          options.fileName=filesname;
          obj["FileName"]=filesname;
      options.params={"RequestBody":JSON.stringify(obj)};
      fileTransfer.upload(FILE_URI,app.UPLOADURL,options).then(data=>{
        if(data.responseCode == 200){
          let message = JSON.parse(data.response);
          if(message.ResponseMessage.Success){
            message.Status.forEach((element,index) => {
              message.Status[index].FileHostName = app.WEBSITE+element.FileHostName;
            });
          }
          resolve(message);
        }
     }).catch(error=>{
       console.log(error);
       reason(error);
      //  that.msg.Show("上传失败,请联系管理员");
     });

    });
  }
    /**
   * 同步压缩图片上传
   * @param imageUrl 返回base64位图片字符串
   * @param imageType 文件类型，1：jpg;2:png
   * @param size 压缩大小
   */
  CompressAccurately(imageUrl:string,imageType:number = 1, size:number = 600 ){
    const that= this;
    let imgtype="image/jpeg";
    if(imageType==2){
      imgtype="image/png";
    }
    let ext = ".jpg";
    if(imageType==2){
      ext=".png";
    }     
    let imgName = that.GetImgFileName();   
    let FileName = "["+imgName+"]"+imgName+".jpg";
    let isf:boolean = false;
    if(that.platform.is("android")){//android系统手机
      if(that.device.version){//版本号存在
        if(that.device.version.toString().startsWith("5")){//当前版本小于等于5.0
          isf=true;
        }else
        if(that.device.version.toString().startsWith("4")){//当前版本小于等于4.0
          isf=true;
        }else
        if(that.device.version.toString().startsWith("3")){//当前版本小于等于3.0
          isf=true;
        }
      }
    }
    console.log(imageType);
    return new Promise<any>((resolve,reject)=>{
         
      if(!isf){
        imageConversion.dataURLtoFile(imageUrl,imgtype).then(file=>{
          imageConversion.compressAccurately(file, size).then(blob => {
           
            that.RequestFormData(app.UPLOADURL,blob,ext,FileName).then(data=>{
              resolve(data);
            }).catch(error=>{
              reject(error);
            });                                                     
          });
        });
    }else{
      that.RequestFormData(app.UPLOADURL,imageUrl,ext,FileName,true).then(data=>{
        resolve(data);
      }).catch(error=>{
        reject(error);
      });  
    }
    });
  }
  /**
   * 文件上传
   * @param url  文件上传api地址
   * @param file  文件地址,64位地址或者文件路劲地址
   * @param ext 文件类型
   * @param fileName 文件名称
   * @param isbase64 是否64位字符串，默认false
   */
  RequestFormData(url:any,file:any,ext:string,fileName:string,isbase64:boolean=false):Promise<any>{
    const that =this;
    return new Promise<any>((resolve,reject)=>{
      let Msg = new WebResponesContext();
      Msg.ResponseMessage.Success = false;
      Msg.ResponseMessage.ErrorMessage = "目前网络繁忙，请稍后再试";

      let formData = new FormData();                                 
      formData.append('files',file,new Date().getTime() + ext);
      let store = that.common.GetStorageKey("tbstore");
      let obj:any={};
          obj["FileName"]=fileName;
          if(store){//门店地址
            obj["storeId"]=store.ID;
          }
          if(isbase64){//64位字符串
            obj["base64"]=file;
          }
          formData.append('RequestBody',JSON.stringify(obj));
     
      try{
        var request = new XMLHttpRequest();
        // request.setRequestHeader("Content-Type","multipart/form-data; charset=UTF-8");
        request.open('post',url,true);
        // request.setRequestHeader('Authorization',"Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9uYW1lIjoiU0EiLCJJRCI6ImIxYTAzYjMzLThjOGEtNDZjYS04MDRjLTE2NmJmNWIxNDY5YSIsIkRpc3BsYXlOYW1lIjoi6ZSA5ZSu5Luj6KGoIiwiTG9naW5OYW1lIjoiU0EiLCJBcHAiOiJ0cnVlIiwianRpIjoiYjFhMDNiMzMtOGM4YS00NmNhLTgwNGMtMTY2YmY1YjE0NjlhIiwiaWF0IjoiMjAxOS80LzE4IDI6NDU6MjMiLCJuYmYiOjE1NTU1NTU1MjMsImV4cCI6MTU1NTY0MTkyMywiaXNzIjoiaHR0cDovL3d3dy5tb2Jpem9uZS5jbiIsImF1ZCI6Ind3dy5tb2Jpem9uZS5jbiJ9.yGhPdG_90bdr8o8WDjneYdvQ6B4ysk_22Yxw8ZETHFg");
        request.send(formData);
        // request.onload = function(data){
        //   if(data.currentTarget['status'] == 200){
        //     const body = JSON.parse(data.currentTarget['response']);
        //     if (body.ResponseMessage.Success) {
        //         Msg.ResponseMessage.Success=true;
        //         Msg.Status = body.Status;
        //     } 
        //     resolve(Msg);
        //   }else{
        //     reject(Msg);
        //     // that.msg.Alert("图片上传失败");
        //   }
        // }

        request.onreadystatechange = function(data){
          console.log(data,"onreadystatechange");
          if(data.currentTarget["readyState"]==4){
            if(data.currentTarget['status'] == 200){
              const body = JSON.parse(data.currentTarget['response']);
              if (body.ResponseMessage.Success) {
                  Msg.ResponseMessage.Success=true;
                  Msg.Status = body.Status;
              } 
              resolve(Msg);
            }else{
              reject(Msg);
              // that.msg.Alert("图片上传失败");
            }
          }
        }
      }catch(error){
        reject(Msg);
      }
    });
  }
  /**
   * 异步压缩图片上传
   * @param imageUrl 返回base64位图片字符串
   * @param imageType 文件类型，1：jpg;2:png
   * @param size 压缩大小
   * @param postType 上传地址,1表示异步,2同步
   */
  AsyncCompressAccurately(imageUrl:string, imageType:number=1,size:number=600,postType=1){
    const that = this;
                 
    return new Promise<any>((resolve,reject)=>{
      let imgtype = "image/jpeg";
        if(imageType == 2){
          imgtype="image/png";
        }
        let imgName = that.GetImgFileName();   
        let FileName = "["+imgName+"]"+imgName+".jpg";
        let imgNameArr = app.UPLOADFileName + FileName;
        let ext = ".jpg";
        if(imageType==2){
          ext=".png";
        }   
        let url=app.UPLOADURLSYNC;//UPLOADURL;
        if(postType==1){
          url=app.UPLOADURLSYNC;
        }else if(postType==2){//同步
          url=app.UPLOADURL;
        }   
        let isf:boolean = false;
        if(that.platform.is("android")){//android系统手机
          if(that.device.version){//版本号存在
            if(that.device.version.toString().startsWith("5")){//当前版本小于等于5.0
              isf=true;
            }else
            if(that.device.version.toString().startsWith("4")){//当前版本小于等于4.0
              isf=true;
            }else
            if(that.device.version.toString().startsWith("3")){//当前版本小于等于3.0
              isf=true;
            }
          }
        }
        /**
         * 微信
         */
        // if(that.common.IsWeixinBrowser){
        //   isf=true;
        // }
      if(isf){
        that.RequestFormData(url,imageUrl,ext,FileName,true).then(data=>{
          resolve(data);
        }).catch(error=>{
          reject(error);
        }); 
      }else{
      try{
        imageConversion.dataURLtoFile(imageUrl,imgtype).then((file)=>{
          imageConversion.compressAccurately(file, size).then(blob => {
            that.RequestFormData(url,blob,ext,FileName,false).then(data=>{
              resolve(data);
            }).catch(error=>{
              reject(error);
            }); 
          });
        });
      }catch(err){
          that.RequestFormData(url,imageUrl,ext,FileName,true).then(data=>{
            resolve(data);
          }).catch(error=>{
            reject(error);
          }); 
      }
      }
      if(postType==1){//表示异步,先返回结果
        let Msg = new WebResponesContext();
          Msg.ResponseMessage.Success = true;
          Msg.ResponseMessage.ErrorMessage = "目前网络繁忙，请稍后再试";
          Msg.Status=new Array<any>();
          Msg.Status.push({"FileName":imgNameArr})
        resolve(Msg);
      }
    });
  }

  /**
   * 异步图片上传名称
   */
  GetImgFileName(){
    let date:Date = new Date();
    let year,month,day;
    let riqi = date.getFullYear().toString().substring(2,4);
    let tmp1:any = date.getMonth()+1;
    let tmp2:any =  date.getDate();
    month=tmp1;
    day = tmp2;
    if(tmp1 <10){
      month = "0"+tmp1;
    }
    if(tmp2<10){
      day = "0"+tmp2;
    }
    year = riqi;
    return year+month+day+date.getHours()+date.getMinutes()+date.getSeconds()+date.getMilliseconds();
  }


  /**
   * 
   * @param imageUrl 改变图片路径为64位
   */
  Base64File(imageUrl:any):Promise<any>{
    const that= this;
    return new Promise<any>((resolve,reject)=>{
      that.base64.encodeFile(imageUrl).then(data=>{
        console.log(data);
        resolve(data);
      }).catch(err=>{
         console.log(err);
         reject(err);
      });
    });
    
  }
  /**
   * 拨打电话
   * @param _number 电话号码
   */
  GetCallPhone(_number:string){
    // if(this.isMobile){
    //   return this.callNumber.callNumber(_number,true);
    // }else{
    //   return new Promise<string>((resolve,reject)=>{
    //     document.location.href='tel:'+_number;
    //     resolve("成功");
    //   })
    //   //return this.msg.ErrorMessage("非手机端不可使用");
    // }
    return new Promise<string>((resolve,reject)=>{
      document.location.href='tel:'+_number;
      resolve("成功");
    })
    
  }
  /**
   * 发送短信
   * @param phoneNumber 接收的手机号码
   * @param _message 短信内容
   */
  GetSendMsg(phoneNumber:any,_message:string){
    let that=this;
    // if(that.isMobile){
    //   return that.sms.send(phoneNumber,_message);
    // }else{
    //   return new Promise<any>((resolve,reject)=>{
    //     if(that.common.BrowserRedirect==="maxos"){
    //       document.location.href='sms:'+phoneNumber+'&body='+_message;
    //     }else{
    //       document.location.href='sms:'+phoneNumber+'?body='+_message;
    //     }
    //     resolve("成功");
    //   });
       
    //   //return this.msg.ErrorMessage("非手机端不可使用");
    // }
    return new Promise<any>((resolve,reject)=>{
      if(that.common.BrowserRedirect==="maxos"){
        document.location.href='sms:'+phoneNumber+'&body='+_message;
      }else{
        document.location.href='sms:'+phoneNumber+'?body='+_message;
      }
      resolve("成功");
    });
  }

  /**
   * 更新android端App,参考地址:https://beta.ionicframework.com/docs/native/app-update
   *   ---------------实例--------------------
   * <update>
   * <version>302048</version>
   * <name>APK Name</name>
   * <url>https://your-remote-api.com/YourApp.apk</url>
   * </update>
   * @param updateUrl xml地址
   */
  // getUpdateApp(updateUrl:string){
  //   if(this.isMobile && this.isAndroid){
  //     return this.appUpdate.checkAppUpdate(updateUrl);
  //   }else{
  //     return new Promise((DATA_URL)=>{
  //       return "非手机端不支持此功能"
  //     });
  //   }
  // }
  /**
   * 扫码
   */
  // getScandCode(){
  //   let option: ZBarOptions = {
  //     flash: 'off',
  //     text_title: '扫码',
  //     drawSight: false
  //   };
  //  return this.zbar.scan(option);
  // }
  // 观察网络断开
// public disconnectSubscription = this.network.onDisconnect().subscribe(() => {
//   console.log('network was disconnected :-(');
// });

// // stop disconnect watch
// disconnectSubscription.unsubscribe();


// // 观察网络连接
// public connectSubscription = this.network.onConnect().subscribe(() => {
//   console.log('network connected!');
//   // We just got a connection but we need to wait briefly
//    // before we determine the connection type. Might need to wait.
//   // prior to doing any api requests as well.
//   setTimeout(() => {
//     if (this.network.type === 'wifi') {
//       console.log('we got a wifi connection, woohoo!');
//     }
//   }, 3000);
// });

// // 断开网络
// connectSubscription.unsubscribe();
/**
 * 在线生成二维码
 * @param element 当前的dom对象 
 * @param text 需要生成的文本信息
 */
 QRCodeinfo(element,text:string,width:number = 300,height:number = 300){
   let qrcode = new QRCode(element,{
    width : width,
    height : height,
    colorDark : "#000000",
    colorLight : "#ffffff",
    src:"./assets/img/touxiang.jpg"
  });
  qrcode.makeCode(text);
};

/**
 * 获取sim信息
 */
get PhoneNumber():Promise<any>{
  const that = this;
  return new Promise<any>((resolve,reject)=>{
    if(that.isMobile){
      that.sim.getSimInfo().then(data=>{
        resolve(data);
        }).catch(error=>{
          reject(error);
        });
    }else{
      resolve("");
    }
   });
  }
  /**
 * 打开文件
 * @param fileUrl 文件地址 https://xxxxxxxx.com.cn/xx.pdf
 * @param target 文件类型,默认为"application/pdf";
 */
OpenFile(fileUrl:string,target:string="application/pdf"){
  let that = this;
      let transfer = new FileTransfer();
      const fileTransfer:FileTransferObject = transfer.create();
      //const apk = this.file.externalRootDirectory + 'android.apk'; //apk保存的目录
      
      let fileupload:any =fileUrl;
      let index:number= fileUrl.lastIndexOf("\/")+1;
      let filesname = fileUrl.substring(index,fileUrl.length);//获取文件名称
      let apk = that.file.cacheDirectory + filesname;
      let headers = {};
          headers["Content-type"]="application/octet-stream";
          headers["Content-Disposition"]="attachment;filename="+filesname;
          that.fileOpener.open(apk, target)
          .then( success => {
            console.log( success,"文件打开成功" );
          }, error => {
           that.DownLoadFileOpen(fileupload,apk,headers,target);
            console.log( error,"文件打开失败" );
          })
          .catch( error => {
            that.DownLoadFileOpen(fileupload,apk,headers,target);
            console.log( error,"文件打开失败Error" );
          });


}
/**
 * 文件下载并打开
 * @param fileUrl 上传的文件绝对路劲 
 * @param appFile 硬盘文件路劲
 * @param headers 头部文件
 * @param target 文件mintype类型
 */
DownLoadFileOpen(fileUrl:string,appFile:string,headers:any={},target:string="application/pdf"){
    const that =this;
  let transfer = new FileTransfer();
      const fileTransfer:FileTransferObject = transfer.create();
  that.msg.Loading("下载进度：0%").then((loads:HTMLIonLoadingElement)=>{
    console.log(fileUrl,"打开文件前");
  fileTransfer.download(fileUrl,appFile,true,headers ).then(( datas ) => {
    console.log(datas,"下载完文件地址");
    that.fileOpener.open(datas.nativeURL, target)
      .then( success => {
        loads.dismiss();
        console.log( success );
      }, error => {
        loads.dismiss();
        console.log( error );
      })
      .catch( error => {
        loads.dismiss();
        that.msg.Alert(app.ERRORMESSAGE);
        console.log( error );
      } );
  }).catch( error => {
    loads.dismiss();
    that.msg.Alert(app.ERRORMESSAGE);
  });
console.log(loads);
  fileTransfer.onProgress(( event: ProgressEvent ) => {
    let num = Math.floor( event.loaded / event.total * 100 );
    if ( num === 100 )
    {
      loads.message = '下载完成准备打开中,请稍后';
      loads.dismiss();
    } else
    {
      //console.log(loads);
      let title = num;
      title && ( loads.message = '下载进度：' + num + '%' );
    }
  });
loads.present();
});
}
   /**
  * 下载安装app
  */
 downloadApp(url:any=null) {
  let that = this;
   that.msg.Loading("下载进度：0%").then((loads:HTMLIonLoadingElement)=>{
      let transfer = new FileTransfer();
      const fileTransfer:FileTransferObject = transfer.create();
      //const apk = this.file.externalRootDirectory + 'android.apk'; //apk保存的目录
      let apk = that.file.externalDataDirectory + 'android.apk';
      let fileupload:any = "";
      if(url){
        fileupload = url;
      }else{
          if(!app.RELEASE){//测试地址
            apk = that.file.externalDataDirectory + 'androidtest.apk';
            fileupload = app.DOWNLOAD_ANDROID_URL_TEST;
          }else{
              fileupload = app.DOWNLOAD_ANDROID_URL;
          }
      }
      fileTransfer.download(fileupload, apk ).then(( datas ) => {
        that.fileOpener.open(apk, "application/vnd.android.package-archive" )
          .then( success => {
            loads.dismiss();
            console.log( success );
          }, error => {
            loads.dismiss();
            console.log( error );
          })
          .catch( error => {
            loads.dismiss();
            that.msg.Alert("目前网络繁忙，请稍后再试");
            console.log( error );
          } );
      }).catch( error => {
        loads.dismiss();
        that.msg.Alert("目前网络繁忙，请稍后再试");
      });
      console.log(loads);
      fileTransfer.onProgress(( event: ProgressEvent ) => {
        let num = Math.floor( event.loaded / event.total * 100 );
        if ( num === 100 )
        {
          loads.message = '下载完成准备安装,请稍后';
          loads.dismiss();
        } else
        {
          console.log(loads);
          let title = num;
          title && ( loads.message = '下载进度：' + num + '%' );
        }
      });
      loads.present();
    });
}
 /**
  * 日期下拉控件
  * @param config  表示一个对象,其中 type:default-默认”年月日时分秒“，”yyyymmdd“，”yyyymm“,"hhmmss","hhmm";默认"default";
  * （其中:Y表示”年“，m表示”月“，d表示”天“，”h“表示小时，”m“表示分钟过，”s“表示秒。）
  * “value”：表示选中的值，默认当前年月日。
  */
 IosselectDateTime(config:any={}):Promise<any>{
  const that =this;
  let now = new Date();
        // debugger;
     let values = now.getFullYear()+"-"+(now.getMonth() + 1)+"-"+now.getDate()+" "+now.getHours()+":"+now.getMinutes()+":"+now.getSeconds();
      config = Object.assign({"format":"default","value":values},config);
  // console.log(config);
  let arrayData:any;
    let oneLevelId:any = "";//now.getFullYear();
    let twoLevelId:any = "";//now.getMonth() + 1;
    let threeLevelId:any = "";//now.getDate();
    let fourLevelId:any ="";// now.getHours();
    let fiveLevelId:any ="";// now.getMinutes();
    let sixLevelId:any = "";//now.getSeconds();
  let year =that.common.FormatYear;
  let month =that.common.FormatMonth;
  let hours =that.common.GetHourData;
  let minutes =that.common.GetMinuteData;
  let seconds =that.common.GetSecondsData;
  let countTime:number = 6;
       /**
     * 关联月份
     * @param year 
     * @param month 
     */
    let  GetDateDay=function (year, month, callback) {
      if (/^(1|3|5|7|8|10|12)$/.test(month)) {
          callback(that.common.FormatDate(31));
      }
      else if (/^(4|6|9|11)$/.test(month)) {
          callback(that.common.FormatDate(30));
      }
      else if (/^2$/.test(month)) {
          if (year % 4 === 0 && year % 100 !==0 || year % 400 === 0) {
              callback(that.common.FormatDate(29));
          }
          else {
              callback(that.common.FormatDate(28));
          }
      }
      else {
          throw new Error('month is illegal');
      }
  };
  arrayData=[year,month,GetDateDay,hours,minutes,seconds];
  if(config.value){
    let datavalue=that.common.FormatDateData(config.format,config.value);
    if(datavalue.length>0){
      
      if(datavalue[0]){
        oneLevelId = datavalue[0].toString();
      }
      if(datavalue[1]){
        twoLevelId = datavalue[1].toString();
      }
      if(datavalue[2]){
        threeLevelId = datavalue[2].toString();
      }
      if(datavalue[3]){
        fourLevelId = datavalue[3].toString();
      }
      if(datavalue[4]){
        fiveLevelId = datavalue[4].toString();
      }
      if(datavalue[5]){
        sixLevelId = datavalue[5].toString();
      }
    }
  }else{
    switch(config.format){
      case "yyyymmdd"://年月日
      oneLevelId = now.getFullYear();
      twoLevelId = now.getMonth() + 1;
      threeLevelId = now.getDate();
        break;
        case "yyyymm"://年月
        oneLevelId = now.getFullYear();
        twoLevelId = now.getMonth() + 1;
        break;
        case "hhmmss"://时分秒
        fourLevelId = now.getHours();
        fiveLevelId = now.getMinutes();
        sixLevelId = now.getSeconds();
          break;
          case "hhmm"://时分
          fourLevelId = now.getHours();
          fiveLevelId = now.getMinutes();
          break;
          case "default":
          case "yyyymmddhhmmss":
              oneLevelId = now.getFullYear();
              twoLevelId = now.getMonth() + 1;
              threeLevelId = now.getDate();
              fourLevelId = now.getHours();
              fiveLevelId = now.getMinutes();
              sixLevelId = now.getSeconds();
            break;

    }
  }
  switch(config.format){
    case "yyyymmdd"://年月日
        countTime = 3;
        arrayData=[year,month,GetDateDay];
      break;
      case "yyyymm"://年月
        countTime = 2;
        arrayData=[year,month];
      break;
      case "hhmmss"://时分秒
          countTime = 3;
          arrayData=[hours,minutes,seconds];
        break;
        case "hhmm"://时分
          countTime = 2;
          arrayData=[hours,minutes];
        break;

  }

  return new Promise<any>((resolve,reject)=>{
    new IosSelect(countTime,arrayData,{
      title: '日期选择',
      itemHeight: 35,
      itemShowCount: 9,
      oneLevelId: oneLevelId,
      twoLevelId: twoLevelId,
      threeLevelId: threeLevelId,
      fourLevelId: fourLevelId,
      fiveLevelId: fiveLevelId,
      sixLevelId: sixLevelId,
      callback:function(selectOneObj, selectTwoObj, selectThreeObj, selectFourObj, selectFiveObj, selectSixObj){
        let obj={};
          // obj["year"]=selectOneObj;
          // obj["month"]=selectTwoObj;
          // obj["day"]=selectThreeObj;
          // obj["hours"]=selectFourObj;
          // obj["minutes"]=selectFiveObj;
          // obj["seconds"]=selectSixObj;
          // console.log(obj);
          switch(config.format){
            case "yyyymmdd"://年月日
              obj["value"]=selectOneObj.id+"-"+selectTwoObj.id+"-"+selectThreeObj.id;
              obj["text"]=selectOneObj.value+selectTwoObj.value+selectThreeObj.value;
              break;
              case "yyyymm"://年月
              obj["value"]=selectOneObj.id+"-"+selectTwoObj.id;
              obj["text"]=selectOneObj.value+selectTwoObj.value;
              
              break;
              case "hhmmss"://时分秒
              obj["value"]=selectOneObj.id+":"+selectTwoObj.id+":"+selectThreeObj.id;
              obj["text"]=selectOneObj.value+selectTwoObj.value+selectThreeObj.id;
                break;
                case "hhmm"://时分
                obj["value"]=selectOneObj.id+":"+selectTwoObj.id;
                obj["text"]=selectOneObj.value+selectTwoObj.value;
                break;
                case "default":
                case "yyyymmddhhmmss":
                    obj["value"]=selectOneObj.id+"-"+selectTwoObj.id+"-"+selectThreeObj.id+" "+selectFourObj.id+":"+selectFiveObj.id+":"+selectSixObj.id;
                    obj["text"]=selectOneObj.value+selectTwoObj.value+selectThreeObj.value+selectFourObj.value+selectFiveObj.value+selectSixObj.value;
                  break;
          }
        resolve(obj);
      },
      fallback: function () {
        let _errobj={};
        _errobj["message"]="取消";
        _errobj["type"]="cancel"
        reject(_errobj);
        },
       maskCallback: function () {
                  let _errobj={};
                  _errobj["type"]="colse"
                  _errobj["message"]="关闭";
                  reject(_errobj);
       }
    });
  });
}
Iosselect(onwData:Array<any>,twoData:Array<any>,dataLevel:any){
  return new Promise<any>((resolve,reject)=>{
    let oneLevelId = dataLevel[0];
    let twoLevelId = dataLevel[1];
    let iosSelect = new IosSelect(2,
        [onwData, twoData],
        {
            title: '地址选择',
            itemHeight: 35,
            relation: [1, 1, 0],
            oneLevelId: oneLevelId,
            twoLevelId: twoLevelId,
            showLoading:true,
            callback: function (selectOneObj, selectTwoObj) {
                    let obj:Array<any>=[];
                    obj.push(selectOneObj);
                    obj.push(selectTwoObj);
              resolve(obj)
            },
            fallback: function () {
              let _errobj={};
              _errobj["message"]="取消";
              _errobj["type"]="cancel"
              reject(_errobj);
              },
             maskCallback: function () {
                        let _errobj={};
                        _errobj["type"]="colse"
                        _errobj["message"]="关闭";
                        reject(_errobj);
             }
    });
  });
}
/**
 * 同步日志
 */
LogSyn(){
  const that =this;
          if(that.platform.is("cordova")){
            that.common.GeAllFieldsList().then(data=>{
              // that.msg.Show("日志同步成功");
              console.log(data,"日志");
              if(data.length>0){
                data.forEach(fied=>{
                 if(fied.isFile){
                    let index:number= fied.name.lastIndexOf(".")+1;
                    let filesname = fied.name.substring(index,fied.name.length);//获取文件名称类型
                    if(filesname=="txt"){//获取过滤txt文件
                        let parms={};
                        parms["storeId"]=null;
                        parms["TBProductBrand_ID"]=that.common.GetAccount.Id;//类型ID
                        let filesType:any = that.common.GetAccount.LoginName;
                        if(!filesType){filesType="login";}
                        parms["SavePath"]="uploads/AppError/"+filesType;//分类类型
                        that.UploadFile(fied.nativeURL,parms,"text/plain").then(result=>{
                            let fileIdex:number = fied.name.lastIndexOf("/")+1;
                              let fileName:any = fied.name.substring(fileIdex,fied.name.length);//获取文件名称
                              let fileUrl:any=fied.nativeURL.substring(0,fied.nativeURL.lastIndexOf("/"));
                            that.file.removeFile(fileUrl,fileName).then(data=>{
                              console.log(data,"日志删除成功");
                            }).catch(err=>{
                                console.log(err,"日志删除失败");
                            });
                      }).catch(err=>{
                        // that.msg.Show("暂无日志");
                      });
                    }
                 }
                });
              }else{
                // that.msg.Show("暂无日志");
              }
            }).catch(err=>{
              console.log(err);
            }); 
          }
   
}
/**
 * 日志删除
 */
DeleteLog(){
  const that =this;
  if(that.platform.is("cordova")){
    that.common.GeAllFieldsList().then(data=>{
      console.log(data,"日志");
      if(data.length>0){
        data.forEach(fied=>{
         if(fied.isFile){
            let index:number= fied.name.lastIndexOf(".")+1;
            let filesname = fied.name.substring(index,fied.name.length);//获取文件名称
            if(filesname=="txt"){//获取过滤txt文件
                  that.file.removeFile(fied.nativeURL,filesname).then(data=>{
                    console.log(data,"日志删除成功");
                  }).catch(err=>{
                      console.log(err,"日志删除失败");
                  });
            }
         }
        });
      }else{
        // that.msg.Show("暂无日志");
      }
    }).catch(err=>{
      console.log(err);
    }); 
  }

}
/**
 * 文件上传,带上传比例
 * @param fileUrl 当前上传的文件路径,只能是路劲不能是base64位
 * @param options 当前上传需要传递的参数{"fileName":"xxxx"}.默认为{}
 */
UpLoad(fileUrl:string,options:any={}):Promise<WebResponesContext>{
  const that = this;
  let webContext:WebResponesContext=new WebResponesContext();
      webContext.ResponseMessage.Success=false;
      webContext.ResponseMessage.ErrorMessage="上传失败";
      console.log(fileUrl,"文件名称2");
  return new Promise<WebResponesContext>((resolve,reject)=>{
      let transfer = new FileTransfer();
      const fileTransfer: FileTransferObject = transfer.create();
      let option: FileUploadOptions = {
        fileKey: 'file',
        fileName: that.GetImgFileName() + ".jpg",
        // mimeType: "image/jpeg",
        httpMethod: "post",
        headers: null
      };
      // option.params["RequestBody"]=JSON.stringify(options);
      let _msg = "已上传"
      that.msg.Loading(_msg).then(load => {
        fileTransfer.upload(fileUrl, app.UPLOADURL, option).then(data => {
          load.dismiss();
          if (data.responseCode == 200) {
            let message = JSON.parse(data.response);
                webContext.ResponseMessage=message.ResponseMessage;
            if (message.ResponseMessage.Success && message.Status.length > 0) {
                 webContext.Status=message.Status;
                 resolve(webContext);
            }else{
                reject(webContext);
            }
          }
        }).catch(error => {
          load.dismiss();
          console.log(error);
            webContext.ResponseMessage.Success=false;
            webContext.ResponseMessage.ErrorMessage=error;
          reject(webContext);
          // that.msg.Alert("上传失败,请检查网络！");
        });
        fileTransfer.onProgress((event: ProgressEvent) => {
          let num = Math.floor(event.loaded / event.total * 100);
          console.log(num, "百分比")
          if (num === 100) {
            load.message = '上传完成';
            load.dismiss();
          } else {
            let title = num;
            title && (load.message = _msg + num + '%');
          }
        });
        load.present();
      });
  });
}

}


